<template>
  <ul class="mockup-list">
    <li class="mockup-list__item" v-for="(mockup, i) in mockups" :key="i">
      <h1 class="mockup-list__item-title">
        {{ `${mockup.material}` }}
        <span class="mockup-list__item--disabled">
          {{ mockup.active ? "" : "(disabled)" }}
        </span>
      </h1>
      <div
        class="mockup__btn-icon"
        @click="mockup === '' ? null : $emit('output', mockup.material)"
      >
        <icon-pencil />
      </div>
    </li>
  </ul>
</template>

<script>
import { getMockups } from "@/api/catalog-api/mockup-api/mockup.api.js";
import IconPencil from "@gocasebr/go-shared/dist/pencil/Pencil";

export default {
  components: { IconPencil },
  data() {
    return {
      mockups: [],
    };
  },
  async mounted() {
    await getMockups().then((res) => (this.mockups = res));
  },
};
</script>

<style lang="scss" scoped>
.mockup-list {
  display: grid;
  gap: 6px;
  padding: 6px;
  margin: 0;

  &__item {
    display: grid;
    grid-template-columns: 1fr auto;
    background-color: #f2f2f4;
    padding: 6px;

    &--disabled {
      color: rgba($color: #000000, $alpha: 0.5);
    }

    &-title {
      margin: 0;
      display: flex;
      align-items: center;
    }
  }
}
</style>
